var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 2H3C2.73478 2 2.48043 2.10536 2.29289 2.29289C2.10536 2.48043 2 2.73478 2 3V5.59C2 6.113 2.213 6.627 2.583 6.997L8 12.414V20C8.0002 20.1704 8.04387 20.3379 8.1269 20.4867C8.20992 20.6354 8.32955 20.7605 8.47444 20.8502C8.61934 20.9398 8.78471 20.9909 8.9549 20.9988C9.1251 21.0066 9.29447 20.9709 9.447 20.895L13.447 18.895C13.786 18.725 14 18.379 14 18V12.414L19.417 6.997C19.787 6.627 20 6.113 20 5.59V3C20 2.73478 19.8946 2.48043 19.7071 2.29289C19.5196 2.10536 19.2652 2 19 2ZM12.293 11.293C12.2 11.3857 12.1262 11.4959 12.0759 11.6172C12.0256 11.7386 11.9998 11.8687 12 12V17.382L10 18.382V12C10.0002 11.8687 9.9744 11.7386 9.92412 11.6172C9.87383 11.4959 9.80004 11.3857 9.707 11.293L4 5.59V4H18.001L18.003 5.583L12.293 11.293Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/Filter.2d92135499cf8ab104b3997de0a65952.svg";
export { ForwardRef as ReactComponent };